import { render } from "./Service.vue?vue&type=template&id=3d46c713&scoped=true&ts=true"
import script from "./Service.vue?vue&type=script&lang=ts"
export * from "./Service.vue?vue&type=script&lang=ts"

import "./Service.vue?vue&type=style&index=0&id=3d46c713&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/atomic-design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d46c713"]])

export default __exports__